export enum GroupFormat {
  RoundRobin = 'RoundRobin',
  Bracket = 'Bracket',
}
